export default __webpack_public_path__ + "static/media/ufl.5cf1442e.png";